import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styled from 'styled-components';

import {ComponentProps} from 'react';

import {TelephonyGroupMemberRow} from './TelephonyGroupMemberRow';

type SortableTelephonyGroupMemberRowProps = Omit<
  ComponentProps<typeof TelephonyGroupMemberRow>,
  'handleProps'
>;

const SortableItemWrapper = styled.div<{
  $transform: string | undefined;
  $transition: string | undefined;
  $isDragging: boolean;
}>`
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0.4 : 1)};
`;

export function SortableTelephonyGroupMemberRow(props: SortableTelephonyGroupMemberRowProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.userId,
    disabled: props.isReadOnly,
  });

  return (
    <SortableItemWrapper
      ref={setNodeRef}
      $transform={transform ? CSS.Transform.toString(transform) : undefined}
      $transition={transition}
      $isDragging={isDragging}
    >
      <TelephonyGroupMemberRow {...props} handleProps={{...attributes, ...listeners}} />
    </SortableItemWrapper>
  );
}
